module.exports = __webpack_public_path__ + "static/media/7.019f5257.png";